import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import TreeView from '@material-ui/lab/TreeView';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import TreeItem from '@material-ui/lab/TreeItem';
import CancelPresentationOutlinedIcon from '@material-ui/icons/CancelPresentationOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';

import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware'
import * as SupplierTypes from '../../../../magic-strings/supplier-type';
const HotelRequestDetails = ({ hotelResources }) => {
    const [user] = useState(checkTokenExpirationMiddleware());

    return (
        <>
            {
                hotelResources.map((resource, index) =>
                    <Paper key={index} className="detail-wrapper">
                        <Typography variant="button" display="block" gutterBottom>
                            <b>{user.SupplierType === SupplierTypes.Hotel ? 'Hotel' : resource.hotelName} in {resource.destinationName}</b>
                        </Typography>
                        <Typography variant="body1" display="block" gutterBottom>
                            Check In: {resource.plannedFromDate.substring(0, 10)}, Check Out: {resource.plannedToDate.substring(0, 10)}
                        </Typography>
                        <Typography variant="body2" display="block" gutterBottom>
                            Alternative Dates: [{resource.alternativeFromDate.substring(0, 10)} To {resource.alternativeToDate.substring(0, 10)}]
                        </Typography>
                        {
                            resource.note && resource.note.trim() !== "" ?
                                <Typography variant="body2" display="block" gutterBottom>
                                    Notes: <b>{resource.note}</b>
                                </Typography>
                                : null
                        }
                        <Divider />
                        {
                            resource.reservationRequestHotelRoomResources.length > 0 ?
                                <Grid container>
                                    <Grid container item xs={12} key={index}>
                                        <TreeView
                                            defaultCollapseIcon={<ExpandMoreIcon />}
                                            defaultExpandIcon={<ChevronRightIcon />}
                                            defaultEndIcon={<CancelPresentationOutlinedIcon fontSize="small" />}
                                        >
                                            <TreeItem nodeId="0" label="Acommodation Rooms Details">
                                                {
                                                    resource.reservationRequestHotelRoomResources.map((room, index) => (
                                                        <TreeItem
                                                            key={index}
                                                            nodeId={`${index + 1}`}
                                                            label={
                                                                <>
                                                                    <Typography variant="body2" display="block" gutterBottom>
                                                                        <b>{room.plannedNoofrooms}</b> Rooms, <b>{room.plannedNoofnights}</b> Nights - Type: <b>{room.roomType1}</b>, View: <b>{room.roomView1}</b>
                                                                    </Typography>
                                                                    {
                                                                        room.note && room.note.trim() !== "" ?
                                                                            <Typography variant="body2" display="block" gutterBottom>
                                                                                Notes: {room.note}
                                                                            </Typography>
                                                                            : null
                                                                    }
                                                                </>
                                                            }
                                                        />
                                                    ))
                                                }
                                            </TreeItem>
                                        </TreeView>
                                    </Grid>
                                </Grid>
                                : null
                        }
                        {
                            resource.reservationRequestMeetingRoomResources.length > 0 ?
                                <>
                                    <Grid container>
                                        <Grid container item xs={12}>
                                            <TreeView
                                                defaultCollapseIcon={<ExpandMoreIcon />}
                                                defaultExpandIcon={<ChevronRightIcon />}
                                                defaultEndIcon={<CancelPresentationOutlinedIcon fontSize="small" />}
                                            >
                                                <TreeItem nodeId="0" label="Meeting Rooms Details">
                                                    {
                                                        resource.reservationRequestMeetingRoomResources.map((room, index) => (
                                                            <TreeItem
                                                                key={index}
                                                                nodeId={`${index + 1}`}
                                                                label={
                                                                    <>
                                                                        <Typography variant="body2" display="block" gutterBottom>
                                                                            Setup: <b>{room.roomSetup}</b>, <b>{room.noofattendees}</b> Persons
                                                                        </Typography>
                                                                        <Typography variant="body2" display="block" gutterBottom>
                                                                            {room.needCoffeebreak ? <>Coffe Break [{<CheckOutlinedIcon style={{ verticalAlign: `bottom` }} fontSize="small" />}]</> : null}
                                                                            {room.needSoundsystem ? <> Sound System [{<CheckOutlinedIcon style={{ verticalAlign: `bottom` }} fontSize="small" />}]</> : null}
                                                                            {room.needScreen ? <> Screen [{<CheckOutlinedIcon style={{ verticalAlign: `bottom` }} fontSize="small" />}]</> : null}
                                                                            {room.needProjector ? <> Projector [{<CheckOutlinedIcon style={{ verticalAlign: `bottom` }} fontSize="small" />}]</> : null}
                                                                        </Typography>
                                                                        {
                                                                            room.notes && room.notes.trim() !== "" ?
                                                                                <Typography variant="body2" display="block" gutterBottom>
                                                                                    Notes: {room.notes}
                                                                                </Typography>
                                                                                : null
                                                                        }
                                                                    </>
                                                                }
                                                            />
                                                        ))
                                                    }
                                                </TreeItem>
                                            </TreeView>
                                        </Grid>
                                    </Grid>
                                </>
                                : null
                        }
                    </Paper>
                )
            }
        </>
    )
}

export default HotelRequestDetails;